/**
 * Chuỗi hiển thị của nhóm màn hình "Biên tập nội dung" (MH-11, MH-12, MH-13,
 * MH-14 hàng đợi, chọn loại nội dung) dựng lại theo bản mẫu CMS. Chuỗi dùng
 * chung đã có trong `vi.ts` thì đọc từ đó, không khai lại ở đây.
 */
export const viBienTapNoiDung = {
  /* --------------------------- Danh sách nội dung --------------------------- */
  danhSach: {
    nutBienTap: 'Biên tập nội dung',
    locTen: 'Tên bản tin',
    locTenGoiY: 'Nhập tên bản tin...',
    locNgayCapNhat: 'Ngày cập nhật',
    locNgayGiaiThich: 'Lọc theo thời gian sản xuất của bản tin (máy chủ chưa lọc theo thời điểm cập nhật)',
    locTuNgay: 'Từ ngày',
    locDenNgay: 'Đến ngày',
    locTrangThai: 'Trạng thái',
    tatCa: 'Tất cả',
    cot: {
      stt: 'STT',
      tenBanTin: 'Tên bản tin',
      diaBan: 'Địa bàn',
      thoiLuong: 'Thời lượng',
      trangThai: 'Trạng thái',
      mucDoUuTien: 'Mức độ ưu tiên',
      thoiGianCapNhat: 'Thời gian cập nhật',
      nguoiTao: 'Người tạo',
      thaoTac: 'Thao tác',
      tieuDe: 'Tiêu đề',
      loaiBanTin: 'Loại bản tin',
      linhVucCap1: 'Lĩnh vực cấp 1',
      linhVucCap2: 'Lĩnh vực cấp 2',
      nguonTin: 'Nguồn tin',
      ngayTao: 'Ngày tạo',
    },
    chinhSua: 'Chỉnh sửa',
    xoa: 'Xóa',
    trinhDuyet: 'Trình duyệt',
    trinhDuyetGoiY: 'Gửi bản tin sang Trình phê duyệt',
    guiDuyet: 'Gửi duyệt',
    daGuiDuyet: 'Đã gửi duyệt bản tin "{ten}"',
    timKiem: 'Tìm kiếm',
    datLichPhat: 'Đặt lịch phát',
    layVeKho: 'Lấy về kho',
    nguoiTaoChuaCo: 'Máy chủ chưa trả tên người tạo (chỉ có mã người tạo) — chưa có API',
    xoaTieuDe: 'Xóa bản tin',
    xoaHeQua: 'Xóa 1 bản tin "{ten}" khỏi Kho nội dung cá nhân. Thao tác không hoàn tác được.',
    daXoa: 'Đã xóa bản tin "{ten}"',
    daTrinhDuyet: 'Đã trình duyệt bản tin "{ten}"',
    loiThaoTac: 'Không thực hiện được: {loi}',
    rongMoTaKhoNguon: 'Chưa có bản tin đã duyệt nào được chia sẻ tới địa bàn của bạn.',
    rongMoTaXuatBan: 'Chưa có bản tin nào đã được duyệt trong phạm vi địa bàn đang xem.',
    // Kho thông tin nguồn
    locNguonTin: 'Nguồn tin',
    chonNguonTin: 'Chọn nguồn tin',
    locLoaiBanTin: 'Chọn loại bản tin',
    locLinhVucCap1: 'Lĩnh vực cấp 1',
    chonLinhVucCap1: 'Chọn loại lĩnh vực cấp 1',
    locLinhVucCap2: 'Lĩnh vực cấp 2',
    chonLinhVucCap2: 'Chọn loại lĩnh vực cấp 2',
  },

  /**
   * Đúng enum `LoaiBanTin` của OpenAPI: 1 văn bản chuyển giọng nói, 2 hình ảnh, 3 âm thanh, 4 video,
   * 5 trực tiếp (hợp đồng gộp kho 29/10/2026 mục 1).
   */
  loaiBanTinNhan: {
    '1': 'Bản tin văn bản (giọng đọc)',
    '2': 'Bản tin hình ảnh',
    '3': 'Bản tin âm thanh',
    '4': 'Bản tin video',
    '5': 'Bản tin trực tiếp',
  },

  /** Ô "Loại bản tin" trên CMS: Âm thanh (mã 1, 3), Hình ảnh (2), Video (4). */
  nhomLoaiNhan: {
    'am-thanh': 'Âm thanh',
    'hinh-anh': 'Hình ảnh',
    video: 'Video',
  },

  /** Đúng enum `MucDoUuTien` của OpenAPI: 1 khẩn cấp, 2 ưu tiên, 3 thông thường. */
  uuTienNhan: {
    '1': 'Khẩn cấp',
    '2': 'Ưu tiên',
    '3': 'Thông thường',
  },

  /* ----------------------------- Trình phê duyệt ---------------------------- */
  hangDoi: {
    duyet: 'Duyệt',
    tuChoi: 'Từ chối',
    duyetGoiY: 'Mở bản tin để nghe trước khi duyệt (bắt buộc nghe trước khi duyệt)',
    tuChoiGoiY: 'Mở bản tin để ghi lý do từ chối',
    chuaNghe: 'Chưa nghe',
    xemTep: 'Xem trước tệp bản tin',
    xacNhanDaXem: 'Xác nhận đã xem',
    khongCoTep: 'Bản tin chưa có tệp để xem.',
  },

  /* --------------------------- Chọn loại nội dung --------------------------- */
  chonLoai: {
    quayLai: 'Quay lại',
    tieuDe: 'Chọn nội dung cần thêm mới',
    taiFile: 'Tải file từ thiết bị',
    taiFilePhu: '(mp3, mp4, wav, image)',
    tts: 'Chuyển văn bản thành giọng đọc',
    vanBan: 'Nhập văn bản trực tiếp',
    catGhep: 'Cắt ghép file',
    trucTiep: 'Bản tin trực tiếp',
    nguon: 'Nguồn từ Cục thông tin cơ sở',
    khongKhaDung: 'Chức năng chưa khả dụng',
  },

  /* ------------------------------ Soạn bản tin ------------------------------ */
  soan: {
    buocTao: 'Tạo bản tin',
    buocTaiTep: 'Tải tệp lên',
    buocHoanThanh: 'Hoàn thành',
    tiepTuc: 'Tiếp tục',
    loaiBanTinGhiChu:
      'Âm thanh dùng cho cả cụm loa và bảng tin điện tử; hình ảnh, video chỉ dùng cho bảng tin điện tử.',
    vungPhatGhiChu: 'Chỉ áp dụng cho bản tin hình ảnh, video.',
    loaiNoiDung: 'Loại nội dung',
    tenBanTin: 'Tên bản tin',
    tenBanTinGoiY: 'Nhập tên bản tin',
    tenBatBuoc: 'Tên bản tin là bắt buộc',
    quyTrinh: 'Quy trình',
    quyTrinhMacDinh: 'Theo quy trình duyệt của đơn vị',
    linhVucCap1: 'Lĩnh vực cấp 1',
    linhVucCap2: 'Lĩnh vực cấp 2',
    chonLinhVucCap2: 'Chọn lĩnh vực cấp 2',
    mucDoUuTien: 'Mức độ ưu tiên',
    nguonTin: 'Nguồn tin',
    loaiBanTin: 'Loại bản tin',
    vungPhat: 'Vùng phát thiết bị',
    vungPhatMacDinh: 'Chọn vùng phát',
    diaBanChiaSe: 'Địa bàn chia sẻ nội dung',
    capSo: 'Cấp sở',
    capXa: 'Cấp xã',
    chonDiaBan: 'Chọn địa bàn',
    chiaSeTinh: 'Chia sẻ lên {ten}',
    chonXa: 'Chọn xã, phường',
    toanBoXa: 'Toàn bộ xã, phường trong tỉnh',
    daChonXa: 'Đã chọn {so} xã, phường',
    chonTatCa: 'Chọn tất cả',
    boChonTatCa: 'Bỏ chọn',
    timXa: 'Tìm xã, phường…',
    ghiChuChiaSe: 'Bản tin sau khi được duyệt sẽ hiện trong Kho thông tin nguồn của địa bàn được chia sẻ.',
    moTa: 'Mô tả (nội dung tóm tắt)',
    quayLai: 'Quay lại',
    taoBanTin: 'Tạo bản tin',
    capNhat: 'Cập nhật',
    dangLuu: 'Đang lưu…',
    loiLuu: 'Không lưu được bản tin: {loi}',
    // Màn hình hoàn thành
    daTao: 'Đã tạo bản tin',
    daCapNhat: 'Đã cập nhật bản tin',
    moTaHoanThanh: '“{ten}” đang ở trạng thái {trangThai} trong Kho nội dung cá nhân.',
    veKho: 'Về Kho nội dung cá nhân',
    trinhNgay: 'Gửi duyệt',
    taoKhac: 'Tạo bản tin khác',
    moBienTap: 'Mở biên tập bản tin',
    daTrinh: 'Đã trình phê duyệt',
    trinhCanDoan: 'Bản tin cần ít nhất một đoạn âm thanh trước khi trình phê duyệt.',
    trinhCanTep: 'Bản tin hình ảnh/video cần tải tệp lên trước khi trình phê duyệt.',
    loiTrinh: 'Không trình duyệt được: {loi}',
    ttsDangTongHop:
      'Giọng đọc đang được tổng hợp trong nền; đoạn âm thanh sẽ được thêm vào bản tin khi xong. Có thể trình phê duyệt sau khi đoạn âm thanh đã có.',
  },

  /* ------------------------ Tải tệp (bản tin hình ảnh / video) ------------------------ */
  tep: {
    nhan: 'Tệp bản tin',
    dinhDangNhan: 'Định dạng nhận: {dinhDang}',
    dinhDang: { '2': 'JPG, JPEG, PNG, WEBP', '4': 'MP4' } as Record<string, string>,
    saiLoai: 'Tệp "{ten}" không đúng loại {loai}. Định dạng nhận: {dinhDang}.',
    thoiLuong: 'Thời lượng video (HH:mm:ss)',
    thoiLuongGoiY: 'Không bắt buộc, ví dụ 00:01:30.',
    thoiLuongSai: 'Thời lượng phải theo dạng HH:mm:ss, ví dụ 00:01:30.',
    taiLen: 'Tải lên',
    dangTaiLen: 'Đang tải lên…',
    tienTrinh: 'Đã gửi {pt}% ({daGui}/{tong} MB)',
    dangXuLy: 'Đã gửi xong, máy chủ đang lưu tệp…',
    tienTrinhNhan: 'Tiến trình tải tệp lên',
    daTaiLen: 'Đã tải lên tệp "{ten}".',
    tepHienTai: 'Tệp hiện tại: {ten}',
    canTaiTep: 'Vui lòng tải tệp lên trước khi tiếp tục.',
    xemTruoc: 'Xem trước',
    khongXemDuoc: 'Không lấy được đường dẫn xem trước tệp.',
    loiTaiLen: 'Không tải được tệp lên: {loi}',
  },

  /** Nhãn "Loại nội dung" theo ô đã chọn ở màn hình chọn loại (tham số `loai`). */
  loaiNoiDungNhan: {
    'tai-file': 'Tải file từ thiết bị',
    'cat-ghep': 'Cắt ghép file',
    tts: 'Chuyển văn bản thành giọng đọc',
  },
} as const;
